<div class="track-my-location-container grid col-12">
  <div class="track-my-location">

    <div class="header col-12 sm:col-12">
      <div class="col-12 md:col-12 lg:col-6 sm:col-12">
        <a href="{{locationDetails?.tenantInfo.siteName}}" target="_blank">
          <img width="200" src="/assets/images/temp/MI_black_logo.png">
        </a>
      </div>
      <div *ngIf="showTrackMyLocationPage" class="col-6 md:col-12 lg:col-6 sm:col-12 grid contact-info">
        <div class="md:col-12 lg:col-6 sm:col-6">
          <strong translate>label_contactNumber</strong>:&nbsp;
          <span>{{locationDetails.tenantInfo.tenantPhoneNum}}</span>
        </div>
        <div class="md:col-12 lg:col-6 sm:col-6">
          <strong translate>label_supportEmail</strong>:&nbsp;
          <span translate>{{locationDetails.tenantInfo.tenantEmail}}</span>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-12 lg:col-12">
      <div class="seperator"></div>
    </div>
    <div>
      <div *ngIf="showTrackMyLocationPage" class="location-info grid col-12 md:col-12 lg:col-12">

        <div class= "md:col-2 lg:col-2 sm:col-12 content">
          <img class="driver-logo" src="{{imageUrl}}">
        </div>

        <div class="lg:col-10 sm:col-12 md:col-10" *ngIf="locationDetails.tourBookingDetailsDto !== undefined && locationDetails.tourBookingDetailsDto !== null" >
            <div class="grid sm:col-12 ">
          <div *ngIf="locationDetails.tourBookingDetailsDto.driverInfo !== undefined && locationDetails.tourBookingDetailsDto.driverInfo !== null"
            class="md:col-6 lg:col-3 sm:col-6 content">
            <div class="content-header" translate>label_driver</div>
            <div class="content-info">
              <div class="data-info">{{locationDetails.tourBookingDetailsDto.driverInfo.firstName}}
                {{locationDetails.tourBookingDetailsDto.driverInfo.lastName}}</div>
              <div class="data-info">{{locationDetails.tourBookingDetailsDto.driverInfo.numCountryCode}}-{{locationDetails.tourBookingDetailsDto.driverInfo.phoneNum}}</div>
              <p class="data-info">{{locationDetails.tourBookingDetailsDto.driverInfo.email}}</p>
              <div class="star">
                <span *ngFor="let star of maxRating;let idx = index">
                  <i *ngIf="idx < locationDetails.tourBookingDetailsDto.driverInfo.driverRating" class="fa fa-star active"></i>
                  <i *ngIf="idx >= locationDetails.tourBookingDetailsDto.driverInfo.driverRating" class="fa fa-star"></i>
                </span>
              </div>
            </div>
          </div>

          <div *ngIf="locationDetails.tourBookingDetailsDto.passengerInfo !== undefined && locationDetails.tourBookingDetailsDto.passengerInfo !== null"
            class="md:col-6 lg:col-3 sm:col-6 content">
            <div class="content-header" translate>label_passenger</div>
            <div class="content-info">
              <div class="data-info">{{locationDetails.tourBookingDetailsDto.passengerInfo.firstName}}
                {{locationDetails.tourBookingDetailsDto.passengerInfo.lastName}}</div>
              <div class="data-info">{{locationDetails.tourBookingDetailsDto.passengerInfo.numCountryCode}}-{{locationDetails.tourBookingDetailsDto.passengerInfo.phoneNum}}</div>
              <p class="data-info">{{locationDetails.tourBookingDetailsDto.passengerInfo.email}}</p>
            </div>
          </div>
          <div *ngIf="locationDetails.tourBookingDetailsDto.vehicleInfo!== undefined && locationDetails.tourBookingDetailsDto.vehicleInfo !== null"
            class="md:col-6 lg:col-3 sm:col-12 content mr-bottom-11">
            <div class="content-header" translate>label_car_details</div>
            <div class="content-info">
              <table>
                <tbody>
                  <tr>
                    <td translate>label_car_type_with_colon </td>
                    <td class="data-info">{{locationDetails.tourBookingDetailsDto.vehicleInfo.vehicleType}} </td>
                  </tr>
                  <tr>
                    <td translate>label_model_with_colon</td>
                    <td class="data-info">{{locationDetails.tourBookingDetailsDto.vehicleInfo.makeModel}}</td>
                  </tr>
                  <tr>
                    <td translate>label_vehicle_type_with_colon</td>
                    <td class="data-info">{{locationDetails.tourBookingDetailsDto.vehicleInfo.vehicleType}} </td>
                  </tr>
                  <tr>
                    <td translate>label_plate_number_with_colon </td>
                    <td class="data-info">{{locationDetails.tourBookingDetailsDto.vehicleInfo.vehicleNumber}} </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div *ngIf="locationDetails.tourBookingDetailsDto.tourBookingInfo !== undefined && locationDetails.tourBookingDetailsDto.tourBookingInfo !== null"
            class="md:col-6 lg:col-3 sm:col-12 content">
            <div class="content-header" translate>label_trip_details</div>
            <div class="content-info">
              <p>
                <i class="fa fa-circle start mr-right-5"></i>{{locationDetails.tourBookingDetailsDto.tourBookingInfo.pickupLocationName}}</p>
              <p>
                <i class="fa fa-circle end mr-right-5"></i>{{locationDetails.tourBookingDetailsDto.tourBookingInfo.dropLocationName}}</p>
              <div>
                <span translate>label_status_with_colon</span>
                <span class="data-info" [ngStyle]="tourStatusColor">{{tourStatus}}</span>
              </div>
             
              
            </div>
          </div>

         
        </div>
        </div>
        <div *ngIf="emergecyrequestedAt"
        class="md:col-12 lg:col-12 sm:col-12 content">
          <!-- <div class="content-header" translate>label_trip_details</div> -->
             <div class="content-info">
         
              <div>
                <span translate>label_emergency_requested_at</span>
                <span class="data-info">{{ emergecyrequestedAt}}</span>
              </div>
              
        </div>
      </div>
      </div>

      <!-- Map -->
      <div class="col-12 md:col-12 lg:col-12 sm:col-12 map-container">
        <div id="trackLocationMap" class="map"></div>
      </div>

    </div>

    <div class="grid col-12 md:col-12 lg:col-12 sm:col-12" *ngIf="(locationDetails?.tenantInfo.appStoreUrl !== '' &&locationDetails?.tenantInfo.appStoreUrl !== null) || locationDetails?.tenantInfo.playStoreUrl !== '' &&locationDetails?.tenantInfo.playStoreUrl !== null">
      <div class="col-6 md:col-12 lg:col-6 sm:col-12 text-center">
        <span translate>lable_for_track_my_location_text</span>
      </div>
      <div class="grid col-6 md:col-12 lg:col-6 sm:col-12">
        <div class="col-1 md:col-1 lg:col-1"></div>
        <div class="col-5 md:col-5 lg:col-5 sm:col-12" *ngIf="locationDetails.tenantInfo.appStoreUrl !== '' &&locationDetails.tenantInfo.appStoreUrl !== null">
          <a href="{{locationDetails.tenantInfo.appStoreUrl}}" target="_blank">
            <img src="/assets/images/temp/app_store.png">
          </a>
        </div>

        <div class="col-5 md:col-5 lg:col-5 sm:col-12" *ngIf="locationDetails.tenantInfo.playStoreUrl !== '' &&locationDetails.tenantInfo.playStoreUrl !== null">
          <a href="{{locationDetails.tenantInfo.playStoreUrl}}" target="_blank">
            <img src="/assets/images/temp/play_store.png">
          </a>
        </div>
        <div class="col-1 md:col-1 lg:col-1 sm:col-12"></div>
      </div>
    </div>

    <div class=" col-12 md:col-12 lg:col-12">
      <div class="seperator"></div>
    </div>

    <div class=" col-12 md:col-12 lg:col-12 sm:col-12">
      <div class="grid col-6 md:col-12 lg:col-6 sm:col-12 text-center">        
        <div class="col-1 md:col-1 lg:col-1 sm:col-2" *ngIf="locationDetails?.tenantInfo.facebookUrl !== '' && locationDetails?.tenantInfo.facebookUrl !== null">
          <a href="{{locationDetails.tenantInfo.facebookUrl}}" target="_blank">
            <img src="/assets/images/temp/footer_fb_icon.png">
          </a>
        </div>

        <div class="col-1 md:col-1 lg:col-1 sm:col-2" *ngIf="locationDetails?.tenantInfo.twitterUrl !== '' && locationDetails?.tenantInfo.twitterUrl !== null">
          <a href="{{locationDetails.tenantInfo.twitterUrl}}" target="_blank">
            <img src="/assets/images/temp/footer_twitter_icon.png">
          </a>
        </div>        
      </div>
    </div>
  </div>

</div>

<div *ngIf="!showTrackMyLocationPage" class="track-my-location-error">
  {{errorMessage}}
</div>